import axios from "@/lib/axios";

const getRegistration = () => {
  return axios.get("/facility/flat_rates/registration");
}

export default getRegistration;